const calz = [
// =========================
  // NIKE
  // =========================

  {
    id: "nike-romaleos-4",
    slug: "nike-romaleos-4",
    name: "Nike Romaleos 4",
    category: "calzado",
    brand: "NIKE",
    sizes: [35,35.5,36,36.5,37,37.5,38,38.5,39,39.5,40,40.5,41,41.5,42.5,43,43.5,44,44.5,45,45.5,46,46.5,47,47.5,48],
    bestSeller: true,
    sizeGuide: "/Guias/sg-nike.jpg",
    variants: [
      { color: "Black", images: ["/Productos/nike-romaleos.avif", "/Productos/nike-romaleos-2.avif", "/Productos/nike-romaleos-3.avif", "/Productos/nike-romaleos-4.avif", "/Productos/nike-romaleos-5.avif"], price: 289 },
      { color: "White", images: ["/Productos/nike-romaleos-w.avif", "/Productos/nike-romaleos-w-2.avif","/Productos/nike-romaleos-w-3.avif","/Productos/nike-romaleos-w-4.avif","/Productos/nike-romaleos-w-5.avif"], price: 289 },
      { color: "Gold", images: ["/Productos/nike-romaleos-g.avif","/Productos/nike-romaleos-gold-2.avif","/Productos/nike-romaleos-gold-3.avif","/Productos/nike-romaleos-gold-4.avif","/Productos/nike-romaleos-gold-5.avif",], price: 289 },
      { color: "Red", images: ["/Productos/romaleos-red.avif","/Productos/nike-romaleos-red-2.avif","/Productos/nike-romaleos-red-3.avif","/Productos/nike-romaleos-red-4.avif","/Productos/nike-romaleos-red-5.avif","/Productos/nike-romaleos-red-6.avif"], price: 289 },
    ],
  },

  {
    id: "nike-savaleos",
    slug: "nike-savaleos",
    name: "Nike Savaleos",
    category: "calzado",
    brand: "NIKE",
    sizes: [35,35.5,36,36.5,37,37.5,38,38.5,39,39.5,40,40.5,41,41.5,42.5,43,43.5,44,44.5,45,45.5,46,46.5,47,47.5,48],
    sizeGuide: "/Guias/sg-nike.jpg",
    variants: [
      { color: "Black", images:[ "/Productos/savaleos.avif","/Productos/savaleos-2.avif","/Productos/savaleos-3.avif","/Productos/savaleos-4.avif","/Productos/savaleos-5.avif","/Productos/savaleos-6.avif",], price: 225 },
      { color: "White", images: ["/Productos/savaleos-w.avif","/Productos/savaleos-w-2.avif","/Productos/savaleos-w-3.avif","/Productos/savaleos-w-4.avif","/Productos/savaleos-w-5.avif","/Productos/savaleos-w-6.avif"], price: 225 },
      { color: "Gold Black", images: ["/Productos/savaleos-gb.webp","/Productos/savaleos-gb-2.webp","/Productos/savaleos-gb-3.jpeg","/Productos/savaleos-gb-4.jpeg","/Productos/savaleos-gb-5.webp","/Productos/savaleos-gb-6.webp"], price: 225 },
      { color: "Gold White", images:[ "/Productos/savaleos-wg.avif","/Productos/savaleos-gw-2.avif","/Productos/savaleos-gw-3.avif","/Productos/savaleos-gw-4.avif","/Productos/savaleos-gw-5.avif","/Productos/savaleos-gw-6.avif"], price: 225 },
      { color: "Silver", images:[ "/Productos/savaleos-sil.avif","/Productos/savaleos-sil-2.avif","/Productos/savaleos-sil-3.avif","/Productos/savaleos-sil-4.avif","/Productos/savaleos-sil-5.avif","/Productos/savaleos-sil-6.avif"], price: 225 },
    ],
  },
  // =========================
  // ADIDAS
  // =========================
  {
    id: "adidas-powerlift",
    slug: "adidas-powerlift",
    name: "Adidas Powerlift",
    category: "calzado",
    sizeGuide: "/Guias/sg-adidas.jpg",
    brand: "ADIDAS",
    sizes: [34.5,35.5,36,36.5,37.5,38,38.5,39,39.5,40,41,41.5,43,43.5,44,45,45.5,46,47,47.5,48],
    variants: [
      { color: "Carbon", images: ["/Productos/adidas-powelift-car.avif","/Productos/powerlift-2.avif"], price: 242.5 },
      { color: "White", images: ["/Productos/adidas-powerlift-bla.avif","/Productos/powerlift-w-2.avif","/Productos/powerlift-w-3.avif"], price: 229 },
    ],
  },

  {
    id: "adidas-adipower",
    slug: "adidas-adipower",
    name: "Adidas Adipower",
    category: "calzado",
    sizeGuide: "/Guias/sg-adidas.jpg",
    brand: "ADIDAS",
    sizes: [35,35.5,36,36.5,37,37.5,38,38.5,39,39.5,40,40.5,41,41.5,42.5,43,43.5,44,44.5,45,45.5,46,46.5,47,47.5,48]  ,
    variants: [
      { color: "Black", image: "/Productos/adidas-adipower-bla.png", price: 310 },
      { color: "Carbon", image: "/Productos/adidas-adipower-car.png", price: 345 },
      { color: "White", image: "/Productos/adidas-adipower-wh.png", price: 345 },
      { color: "Blue", image: "/Productos/adidas-adipower-blu.png", price: 345 },
    ],
  },
  // =========================
  // AVANCUS
  // =========================

  {
    id: "avancus-power-v3",
    slug: "avancus-power-v3",
    name: "Avancus Power V3",
    brand: "AVANCUS",
    sizes: [35,36,37,38,39,40,41,42,43,44,45,46,47],
    category: "calzado",
    bestSeller: true,
    variants: [
      { color: "Stealth", image: "/Productos/ava-neg.webp", price: 120 },
      { color: "White", image: "/Productos/ava-bla.webp", price: 120 },
      { color: "Photon", image: "/Productos/ava-pho.webp", price: 120 },
    ],
  },

  {
    id: "avancus-power-high-top",
    slug: "avancus-power-high-top",
    name: "Avancus Power High Top",
    category: "calzado",
    brand: "AVANCUS",
    sizes: [35,36,37,38,39,40,41,42,43,44,45,46,47],
    bestSeller: true,
    variants: [
      { color: "Stealth", image: "/Productos/ava-h-neg.webp", price: 120 },
      { color: "White", image: "/Productos/ava-h-bla.webp", price: 120 },
      { color: "Ghost", image: "/Productos/ava-ht-gho.webp", price: 120 },
    ],
  },

  // =========================
  // NOTORIOUS LIFT
  // =========================

  {
    id: "nl-radix-pro",
    slug: "notorious-lift-radix-pro",
    name: "Notorious Lift Radix Pro",
    category: "calzado",
    brand: "NOTORIOUS LIFT",
    sizes: [36,37,38,39,40,41,42,43,44,45,46],
    variants: [
      { color: "Black", image: "/Productos/nl-rad-pro.webp", price: 190 },
      { color: "White", image: "/Productos/nl-rad-pro-w.jpg", price: 190 },
      { color: "Blue", image: "/Productos/nl-rad-pro-b.webp", price: 190 },
    ],
  },

  {
    id: "nl-radix",
    slug: "notorious-lift-radix",
    name: "Notorious Lift Radix",
    category: "calzado",
    brand: "NOTORIOUS LIFT",
    sizes: [36,37,38,39,40,41,42,43,44,45,46],
    variants: [
      { color: "Black", image: "/Productos/nl-rad-n.webp", price: 170 },
      { color: "White", image: "/Productos/nl-rad-b.webp", price: 170 },
      { color: "Tanto", image: "/Productos/nl-rad-tanto.webp", price: 170 },
    ],
  },

  {
    id: "nl-sumo-sole-gen4",
    slug: "notorious-lift-sumo-sole-gen4",
    name: "Notorious Lift Sumo Sole Gen 4",
    category: "calzado",
    brand: "NOTORIOUS LIFT",
    sizes: [36,37,38,39,40,41,42,43,44,45,46],
    variants: [
      { color: "Stealth", image: "/Productos/nl-g4-bl.webp", price: 160 },
      { color: "White", image: "/Productos/nl-g4-whi.webp", price: 160 },
      { color: "Monochrome", image: "/Productos/nl-g4-mon.png", price: 160 },
      { color: "Desert", image: "/Productos/nl-g4-des.png", price: 160 },
      { color: "Desert PH", image: "/Productos/nl-g4-des-g.png", price: 160 },
      { color: "Reaper", image: "/Productos/nl-g4-reap.png", price: 160 },
      { color: "Winter", image: "/Productos/nl-g4-wint.webp", price: 160 },
    ],
  },

  {
    id: "nl-sumo-sole-gen2x",
    slug: "notorious-lift-gen2x",
    name: "Notorious Lift Sumo Sole Gen 2X",
    brand: "NOTORIOUS LIFT",
    category: "calzado",
    sizes: [36,37,38,39,40,41,42,43,44,45,46],
    variants: [
      { color: "Stealth", image: "/Productos/nl-g2x-st.webp", price: 135 },
      { color: "Pure White", image: "/Productos/nl-g2x-wh.webp", price: 135 },
      { color: "Bushido", image: "/Productos/nl-2x-bush.webp", price: 135 },
    ],
  },


  // =========================
  // SABO
  // =========================

  {
    id: "sabo-heavy-duty",
    category: "calzado",
    slug: "sabo-heavy-duty",
    name: "Sabo Heavy Duty",
    brand: "SABO",
    sizes: [36,37,38,39,40,41,42,43,44,45,46,47],
    variants: [
      { color: "Black", image: "/Productos/sabo-heavy.webp", price: 220 },
    ],
  },

  {
    id: "sabo-deadlift-pro",
    category: "calzado",
    slug: "sabo-deadlift-pro",
    name: "Sabo Deadlift Pro",
    brand: "SABO",
    sizes: [36,37,38,39,40,41,42,43,44,45,46,47],
    variants: [
      { color: "White/Black", image: "/Productos/sabo-dead-whi.webp", price: 165 },
      { color: "Black/Red", image: "/Productos/sabo-dead-red.Jpg", price: 165 },
      { color: "Red", image: "/Productos/sabo-dead-pro-red.webp", price: 165 },
      { color: "White Night", image: "/Productos/sabo-dead-wn.webp", price: 165 },
      { color: "Black", image: "/Productos/sabo-dead-bla.webp", price: 165 },
      { color: "White", image: "/Productos/sabo-dead-w.webp", price: 165 },
    ],
  },

  {
    id: "sabo-powerlift",
    category: "calzado",
    slug: "sabo-powerlift",
    name: "Sabo Powerlift",
    brand: "SABO",
    sizes: [36,37,38,39,40,41,42,43,44,45,46,47],
    variants: [
      { color: "Classic", image: "/Productos/sabo-powerlift.jpg", price: 165 },
    ],
  },

];

export default calz;
